import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SalesService } from '../sales.service';
import { Sale } from '../sale';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { Branch } from '../../accounting/branch';
import { SelectCustomerDialog } from '../../../shared/dialogs/select-customer-dialog/select-customer-dialog.component';
import { Customer } from '../../accounting/customer';
import { DateRangeDialogComponent } from '../../../shared/dialogs/date-range-dialog/date-range-dialog.component';
import { ReportService } from '../../../shared/services/report.service';
import { MdDialogRef } from '@angular/material';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.scss'],
  providers: [ReportService]
})

export class SalesListComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Sale[];
  subscription: Subscription = new Subscription();
  totalMetersValue: number = 0;

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';
  statusFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'order_number', label: 'Order #', tooltip: 'some tooltip example' },
    { name: 'invoice_number', label: 'Invoice #' },
    { name: 'customer_name', label: 'Client' },
    { name: 'salesman', label: 'Salesman' },
    { name: 'order_date', label: 'Order Date' },
    { name: 'delivery_date', label: 'Delivery Date' },
    { name: 'pieces', label: 'Pieces' },
    { name: 'quantity', label: 'QTY' },
    { name: 'branch', label: 'Branch' },
    { name: 'status', label: 'Status' }
  ];

  filteredData: any[] = [];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;


  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _salesService: SalesService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _reportService: ReportService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this.subscription = this._salesService
      .getSales()
      .subscribe((sales: Sale[]) => {
        this.data = sales.filter((sale: Sale) => { return this._authService.getUserBranches().some((b: Branch) => { return b.code == sale['branch_code'] }) });
        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        //this.selectedRows = this.filteredData;
        this.filter();
        this.totalMetersValue = this.data.reduce((acc, el) => acc + +el.qty, 0);

        this._loadingService.resolve('loading');

      });

    //Use user's branches instead
    //this.allBranches$ = this._salesService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('sale')) {
      this._searchBox.value = this._settingsService.getSearchTerm('sale');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('sale', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    // Need to filter by status?
    if (this.statusFilter != 'ALL') {
      newData = newData.filter((d) => { return d['status'] == this.statusFilter });
    }


    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('sale'), true, excludedColumns);
    this.filteredTotal = newData.length;

    // Sort by date works differently
    if (this.sortBy == 'order_date') {
      newData = newData.sort(
        (d1, d2) => {
          return (new Date(d2[this.sortBy]).getTime() - new Date(d1[this.sortBy]).getTime()) * (this.sortOrder == TdDataTableSortingOrder.Ascending ? 1 : -1)
        }
      );
    } else {
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }


  abbreviation(unit): string {

    switch (unit) {
      case 'Meters²': {
        return 'm²';
      }
      case 'SqFt': {
        return 'SqFt';
      }
      case 'Meters': {
        return 'm';
      }
      case 'Yards': {
        return 'yd';
      }
      default: {
        return '';
      }
    }
  }

  total(data: any[], field: string) {
    if (!data) return;

    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field] || '0') }, 0);
  }

  commissionReport() {
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getCommissionReportData(result.from, result.to + ' 23:59:59').subscribe(
            reportData => {
              if (!(reportData && Array.isArray(reportData))) {
                reportData = [];
              }
              // Filter only the branches in the branch dropdown
              //reportData = reportData.filter((d) => { return d['branch_code'] == this.branchFilter });
              this._reportService.commissionReport(reportData, result.from, result.to);
            }
          );
        }
      }
    );
  }

  salesReport() {
    if (this.branchFilter == 'ALL') {
      this._dialogService.openAlert(
        {
          title: 'Invalid request',
          message: 'Please select a branch from the branch dropdown to generate the report'
        }
      );
      return;
    }
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getSalesReportData(result.from, result.to).subscribe(
            reportData => {
              if (!(reportData && Array.isArray(reportData))) {
                reportData = [];
              }

              // Filter only the branches in the branch dropdown
              reportData = reportData.filter((d) => { return d['branch_code'] == this.branchFilter });

              this._reportService.salesReport(reportData, result.from, result.to);
            }
          );
        }
      }
    );
  }

  branchTransferReport() {
    if (this.branchFilter == 'ALL') {
      this._dialogService.openAlert(
        {
          title: 'Invalid request',
          message: 'Please select a branch from the branch dropdown to generate the report'
        }
      );
      return;
    }
    this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
      result => {
        if (result) {
          this._reportService.getTransferReportData(result.from, result.to).subscribe(
            reportData => {
              if (!(reportData && Array.isArray(reportData))) {
                reportData = [];
              }

              // Filter only the branches in the branch dropdown, and only status RECEIVED and SHIPPED
              reportData = reportData.filter((d) => { return d['branch_from_code'] == this.branchFilter && (d['status'] == 'RECEIVED' || d['status'] == 'SHIPPED') });

              this._reportService.branchTransferReport(reportData, result.from, result.to);
            }
          );
        }
      }
    );
  }

  customerAccountReport() {
    if (this.branchFilter == 'ALL') {
      this._dialogService.openAlert({ title: 'Select Branch', message: 'Please select a branch in the filter to generate the report' });
      return;
    }

    let _customerDialogRef: MdDialogRef<SelectCustomerDialog> = this._dialogService.open(SelectCustomerDialog);
    _customerDialogRef.componentInstance.branch_id = this.branchFilter;
    _customerDialogRef.afterClosed().subscribe(

      //this._dialogService.open(SelectCustomerDialog).afterClosed().subscribe(
      (result: Customer) => {
        if (result) {
          this._dialogService.open(DateRangeDialogComponent).afterClosed().subscribe(
            dates => {
              if (dates) {
                this._reportService.getCustomerAccountReportData(dates.from, dates.to, result.id).subscribe(
                  data => {

                    console.log(data);
                    if (data && data.length > 0) {
                      // assign the selected branch to the customer to be passed in to the report
                      result.branch = this.branchFilter;
                      this._reportService.customerAccountReport(data, result, dates.from, dates.to);
                    } else {
                      this._dialogService.openAlert(
                        {
                          title: 'No data',
                          message: 'There are no invoices for the selected customer at this branch between the selected dates'
                        }
                      );
                    }
                  },
                  error => {
                    this._dialogService.openAlert(
                      {
                        title: 'Error',
                        message: 'There was an error retrieving the data: ' + error
                      }
                    );

                  }
                );

              } else {
                this._dialogService.openAlert(
                  {
                    title: 'Invalid data',
                    message: 'Please select a valid date range'
                  }
                )
              }
            }
          );
        } else {
          this._dialogService.openAlert(
            {
              title: 'Invalid data',
              message: 'Please select a valid customer'
            }
          )
        }
      }
    );
  }

  openConfirm(): void {
    this._dialogService.openConfirm({
      message: 'Are you sure that you want to delete this item?',
      disableClose: false,
      title: 'Confirm',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.selectedRows.forEach(
          (row: Sale) => {
            if (row.customer_id && row.customer_id != 0) {
              // This is a Customer Sale, can delete if it hasn't been prepared or shipped
              
              if ((row.status != 'PREPARED') && (row.status != 'SHIPPED')) {

                this._salesService.deleteOneSale(row.id + '').subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      // Remove this one
                      this._dialogService.openAlert(
                        {
                          title: 'SUCCESS',
                          message: 'Order Deleted ' + row.order_number
                        }
                      );

                      // remove the row from the data and selected rows arrays
                      this.data = this.data.filter(item => { return item.id != row.id });
                      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id });
                      this.filter();

                    } else {
                      this._dialogService.openAlert(
                        {
                          title: 'WARNING',
                          message: 'Could not delete order ' + row.order_number
                        }
                      );
                    }
                  }
                )
              
              } else {
                // Customer asked for the ability to delete shipped and prepared Sales Orders
                // this requires deleting the associated invoice and possibly payments towards that invoice
                this._dialogService.openConfirm({
                  message: 'This order is already approved or shipped!! Are you really sure that you want to delete this item?',
                  disableClose: false,
                  title: 'Confirm',
                }).afterClosed().subscribe((acceptshipped: boolean) => {
                  if (acceptshipped) {
                    this._salesService.deleteOneSale(row.id + '').subscribe(
                      response => {
                        if (response['status'] == 'SUCCESS') {
                          // Remove this one
                          this._dialogService.openAlert(
                            {
                              title: 'SUCCESS',
                              message: 'Order Deleted ' + row.order_number
                            }
                          );

                          // remove the row from the data and selected rows arrays
                          this.data = this.data.filter(item => { return item.id != row.id });
                          this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id });
                          this.filter();

                        } else {
                          this._dialogService.openAlert(
                            {
                              title: 'WARNING',
                              message: 'Could not delete order ' + row.order_number
                            }
                          );
                        }
                      }
                    )
                  } else {
                    // USER REFUSED, DO NOTHING
                  }
                });
              }
            } else {
              if (row.status != 'DRAFT') {
                // B2B are deleted from the originating PO
                this._dialogService.openAlert(
                  {
                    title: 'WARNING',
                    message: 'B2B Sales Orders can only be deleted from the originating PO'
                  }
                );
              } else {
                this._salesService.deleteOneSale(row.id + '').subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      // Remove this one
                      this._dialogService.openAlert(
                        {
                          title: 'SUCCESS',
                          message: 'Order Deleted ' + row.order_number
                        }
                      );
                      
                      // remove the row from the data and selected rows arrays
                      this.data = this.data.filter(item => { return item.id != row.id });
                      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id });
                      this.filter();

                    } else {
                      this._dialogService.openAlert(
                        {
                          title: 'WARNING',
                          message: 'Could not delete order ' + row.order_number
                        }
                      );
                    }
                  }
                )
              }
            }
          }
        );

      } else {
        // USER REFUSED, DO NOTHING
      }
    });
  }

  selectAll() {
    let selected = !this.allSelected();

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } else {
      this.selectedRows = [];
    }

  }

  select(selected: boolean, row) {
    console.log(selected);

    if (selected) {
      if (!this.selectedRows.some(item => { return item.id == row.id })) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id })
    }
  }

  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }

  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected.id == row.id });
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/sales-list/sales-list.component.ts